export function numFilter(value) {
    let realVal = Number(value*100).toFixed(3)
    return Number(realVal)
}
